import React from 'react'
import Header from './Header'
import Footer from './Footer'

const AboutP24 = () => {
    return (
        <div className="app">
        <Header/>
        <div className="privacyPolicy">
            <h1>About Us</h1>
            <br/><br/>
            <p>
              <strong> NIP (VAT):</strong> 5541012980 <br/>

<strong>REGON (Registration Number):</strong> 090412534 <br/>

<strong>Company Address:</strong> ul. Derdowskiego 9/17 85-795 Bydgoszcz <br/> 

<strong>Company Name and Owner:</strong> LOGI DIGITAL KRZYSZTOF WIŚNIEWSKI <br/> 
            </p>
        </div>
        <Footer/>
        </div>
    )
}

export default AboutP24

